// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2EF7N","icons":"Footer_icons__8Nbv-"};